import { makeStyles } from '@material-ui/core';
import theme from '../../theme/booking-theme';

const headerStyles = makeStyles({
  elevationPaper: {},
  mainWrapper: {
    margin: '0 auto',
    marginTop: '3rem',
  },
  subHeader: {
    height: 'auto',
    borderRadius: '5px',
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    maxWidth: 1440,
    margin: '18px auto 0',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '20px 50px',
      height: '140px',
      border: 'none',
      marginTop: 20,
    },
    [theme.breakpoints.up('1441')]: {
      padding: '20px 0px',
    },
    '& .bookingsButton': {
      flex: 0,
      marginBottom: '10px',
      '& button': {
        justifyContent: 'start',
        padding: '0',
        color: theme.palette.blue2,
        fontSize: `${theme.typography.pxToRem(14)} !important`,
        fontFamily: theme.typography.proxima.semiBold,
        height: 'auto',
      },
      '& span > svg': {
        color: theme.palette.blue2,
        marginRight: '12px',
      },
    },
    '& .bookingsHeader': {
      color: theme.palette.grey1,
      alignItems: 'center',
      fontSize: theme.typography.pxToRem(16),
      fontFamily: theme.typography.proxima.bold,
      flex: 1,
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(18),
      },
    },
    '& .bookinsSelect': {
      flex: 2,
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        justifyContent: 'right',
      },
    },
    '& .reservationDetails': {
      fontSize: theme.typography.pxToRem(16),
      display: 'none',
      color: theme.palette.grey1,
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    '& ul': {
      width: '15px',
    },
  },
  selectWrapper: {
    '& .MuiInput-underline:before, .MuiInput-underline:after': {
      display: 'none',
    },

    '& .MuiFormControl-root': {
      minWidth: 130,
    },

    '& svg': {
      transform: 'scale(1.3)',
      transition: 'transform 0.1s ease-in-out',
      marginTop: 1,
      width: 30,
      height: 30,
      [theme.breakpoints.up('md')]: {
        paddingLeft: 0,
        width: 24,
        height: 24,
      },
    },

    '& .open-menu': {
      '& svg': {
        transform: 'rotate(180deg) scale(1.3)',
        transition: 'transform 0.1s ease-in-out',
      },
    },
    '& .select-menu': {
      '& .MuiSelect-selectMenu': {
        paddingRight: 40,
      },
    },
    '& .MuiInput-underline': {
      marginTop: '-7px',
    },
    '& .MuiSelect-select': {
      width: 90,

      '& svg': {
        display: 'none',
      },

      '& .list-item': {
        color: 'transparent',
        display: 'flex',
      },
    },

    '& .MuiSelect-icon': {
      fill: theme.palette.blue2,
    },

    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.blue1,
    },

    '& .MuiSelect-select.MuiSelect-select': {
      backgroundColor: 'transparent',
    },
  },

  customMenu: {
    maxHeight: '600px',
    top: '190px !important',
    marginLeft: 4,
    [theme.breakpoints.up('md')]: {
      top: '170px !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 6,
    },
    '& .MuiMenu-paper': {},
    '& .MuiMenu-list': {
      padding: 0,
    },

    '& li': {
      padding: 15,
      display: 'flex',
      gap: 10,
      whiteSpace: 'normal',
      color: theme.palette.grey1,
      [theme.breakpoints.up('md')]: {
        padding: '20px 30px 15px 20px',
      },
      '& .shipName': {
        fontFamily: theme.typography.proxima.bold,
        textTransform: 'capitalize',
      },
      '& .dates': {
        fontSize: theme.typography.pxToRem(14),
        [theme.breakpoints.up('md')]: {
          fontSize: theme.typography.pxToRem(16),
        },
      },
    },

    '& li:nth-child(even)': {
      backgroundColor: theme.palette.grey4,
    },

    '& .Mui-selected': {
      backgroundColor: 'transparent',

      '& .list-item': {
        color: theme.palette.blue2,
        '& span:nth-of-type(1)': {
          fontSize: theme.typography.pxToRem(14),
          [theme.breakpoints.up('md')]: {
            fontSize: theme.typography.pxToRem(16),
          },
        },
        '& .shipName': {
          fontFamily: theme.typography.proxima.semiBold,
        },
      },

      '& .check-icon': {
        '& svg': {
          display: 'block',
        },
      },
    },
    '& .list-item': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& span:first-child': {
      fontFamily: theme.typography.proxima.semiBold,
    },

    '& .check-icon': {
      width: 24,
      height: 24,

      '& svg': {
        display: 'none',
      },
    },
  },

  resevationNumber: {
    fontSize: theme.typography.pxToRem(12),
    textTransform: 'uppercase',
    paddingLeft: '3px',
    color: theme.palette.grey1,
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  currentInput: {
    marginLeft: 0,
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.blue1,
    fontFamily: theme.typography.proxima.semiBold,
    marginTop: '1px',
  },
});

export default headerStyles;
